animate.$inject = ['$timeout'];

function animate($timeout) {

  return function(scope, element, attr) {
    scope.$watch(attr.animateOnChange, function() {
      element.addClass('changed');
      $timeout(function() {
        element.removeClass('changed');
      }, 300);
    });
  };

}

module.exports = animate;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/animateOnChange.js
 ** module id = 136
 ** module chunks = 1
 **/